import { ROUTES, MENU_LABELS } from '../../config/constants';

export const MainNav = [
  {
    icon: 'ni-dashboard',
    label: MENU_LABELS.DASHBOARD,
    to: ROUTES.DASHBOARD,
    exact: true,
  },
  {
    icon: 'ni-users',
    label: MENU_LABELS.IAEPT_MEMBERS,
    to: ROUTES.STUDENTS,
    matchPrefix: ROUTES.STUDENTS,
  },
  {
    icon: 'ni-building',
    label: MENU_LABELS.CHAPTERS,
    to: ROUTES.GROUPS,
    matchPrefix: ROUTES.GROUPS,
  },
  {
    icon: 'ni-calendar',
    label: MENU_LABELS.EVENT_DIARY,
    to: ROUTES.ASSIGNMENTS,
    matchPrefix: ROUTES.ASSIGNMENTS,
  },
  {
    icon: 'ni-notice',
    label: MENU_LABELS.ANNOUNCEMENT,
    to: ROUTES.STUDY_MATERIAL,
    matchPrefix: ROUTES.STUDY_MATERIAL,
  },
  {
    icon: 'ni-play',
    label: MENU_LABELS.RESOURCES_NEXUS,
    to: ROUTES.STREAMS,
    matchPrefix: ROUTES.STREAMS,
  },
  {
    icon: 'ni-video',
    label: MENU_LABELS.IAEPT_MEETING,
    to: ROUTES.CONFERENCES,
    matchPrefix: ROUTES.CONFERENCES,
  },
  {
    icon: 'ni-check-circle',
    label: MENU_LABELS.CIVIC_CONSENSUS,
    to: ROUTES.QUIZ,
    matchPrefix: ROUTES.QUIZ,
  },
  {
    icon: 'ni-chat',
    label: MENU_LABELS.CHAT_WITH_ARBITRATOR,
    to: ROUTES.DOUBTS,
  },
  {
    icon: 'ni-mail',
    label: MENU_LABELS.SEND_CREDENTIALS,
    to: ROUTES.MESSAGES_STUDENTS,
    matchPrefix: ROUTES.MESSAGES,
  },
  {
    icon: 'ni-reports',
    label: MENU_LABELS.REPORTS,
    to: ROUTES.REPORTS,
  },
  {
    icon: 'ni-user-alt',
    label: MENU_LABELS.VIEW_PROFILE,
    to: ROUTES.SETTINGS,
  },
  {
    icon: 'ni-help',
    label: MENU_LABELS.TECHNICAL_SUPPORT,
    to: ROUTES.FEEDBACK,
  },
  {
    icon: 'ni-compass',
    label: MENU_LABELS.TAKE_A_TOUR,
    to: ROUTES.TOUR,
  },
];
